export default function () {
  return [
    {
      title: '联系日期',
      isEdit: true,
      [$field]: 'contactDate',
    },
    {
      title: '联系人',
      isEdit: true,
      [$field]: 'contactPeople'
    },
    {
      title: '被联系人',
      isEdit: true,
      [$field]: 'byContact'
    },
    {
      title: '联系记录内容',
      isEdit: true,
      [$field]: 'contactContent'
    },
    {
      'title': '操作',
      'width': 200,
      [$field]: 'operate',
      'isOperate': true
    }
  ]
}
